import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { actionPatientWhatsAppMessagesSendMessage } from './actions';
import { NAMESPACE } from './helpers';

type BaseTemplatePayload<T> = {
  patient?: Pick<Components.Schemas.UserPatientProfile, 'firstName' | 'lastName'>;
  currentEmployee?: Pick<Components.Schemas.UserEmployeeProfile, 'firstName' | 'lastName'>;
} & T;

type TemplatePayloadMeeting = {
  meetingEmployee: Pick<Components.Schemas.UserEmployeeProfile, 'firstName' | 'lastName'>;

  meetingFromTime: string;
  meetingFromDate: string;

  meetingToTime: string;
  meetingToDate: string;
};

type TemplatePayloadSignDocument = {
  signDocumentUrl: string;
  signDocumentDuration: string;
  signDocumentExpiredDate: string;
};

type PatientSmsMessageTemplatePayload = BaseTemplatePayload<
  TemplatePayloadMeeting | TemplatePayloadSignDocument | {}
>;

export interface MessageItem {
  uid: string;

  formData: Components.Schemas.WhatsAppMessagePatientRequest;
  templatePayload: PatientSmsMessageTemplatePayload;

  _isLoading: boolean;

  onSuccess?: (result: Components.Schemas.WhatsAppMessagePatientRequest) => void;
  onError?: (error: any) => void;
}

interface State {
  messages: MessageItem[];
}
const initialState = (): State => ({
  messages: [],
});

const slice = createSlice({
  name: NAMESPACE,
  initialState,
  reducers: {
    add(
      state,
      action: PayloadAction<
        Pick<
        MessageItem,
          'uid' | 'formData' | 'templatePayload' | 'onSuccess' | 'onError'
        >
      >,
    ) {
      state.messages.push({
        ...action.payload,
        _isLoading: false,
      });
    },
    remove(
      state,
      action: PayloadAction<Pick<MessageItem, 'uid'>>,
    ) {
      state.messages = state.messages.filter((item) => {
        return item.uid !== action.payload.uid;
      });
    },
  },
  extraReducers(build) {
    build
      .addCase(actionPatientWhatsAppMessagesSendMessage.pending, (state, action) => {
        state.messages = state.messages.map((item) => {
          return item.uid === action.meta.arg.item.uid ? { ...item, _isLoading: true } : item;
        });
      })
      .addCase(actionPatientWhatsAppMessagesSendMessage.fulfilled, (state, action) => {
        state.messages = state.messages.filter((item) => {
          return item.uid !== action.meta.arg.item.uid;
        });
      })
      .addCase(actionPatientWhatsAppMessagesSendMessage.rejected, (state, action) => {
        state.messages = state.messages.map((item) => {
          return item.uid === action.meta.arg.item.uid ? { ...item, _isLoading: false } : item;
        });
      });
  },
});
export const patientWhatsAppMessagesActions = slice.actions;
export const patientWhatsAppMessagesReducer = slice.reducer;
